export default "__VITE_ASSET__DpoCn4oL__"